import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[appInputRestriction]',
    standalone: false
})

// this directive allows only alphanumeric characters, and also prevents pasting of special characters
export class InputRestrictionDirective {
  inputElement: ElementRef;

  @Input() appInputRestriction!: string;
  arabicRegex = '[\u0600-\u06FF]';

  constructor(el: ElementRef) {
    this.inputElement = el;
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (this.appInputRestriction === 'noSpecialChars') {
      this.noSpecialChars(event);
    }
  }

  noSpecialChars(event: KeyboardEvent) {
    const e = event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const k = event.keyCode;

    if (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k === 8 ||
      k === 32 ||
      (k >= 48 && k <= 57)
    ) {
      return;
    }

    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    let regex: RegExp;
    if (this.appInputRestriction === 'integer') {
      regex = /[0-9]/g;
    } else {
      regex = /[a-zA-Z0-9\u0600-\u06FF]/g;
    }

    const pasteData = event.clipboardData
      ? event.clipboardData.getData('text/plain')
      : null;
    let m;
    let matches = 0;
    // eslint-disable-next-line no-cond-assign
    if (pasteData) {
      while ((m = regex.exec(pasteData)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
          matches++;
        });
      }
      if (matches === pasteData.length) {
        return;
      } else {
        event.preventDefault();
      }
    }
  }
}
